import React from 'react';
import styled from 'styled-components';

import error from '../../styles/assets/error.svg';
import asset_stolen_warning from '../../styles/assets/asset_stolen_warning.svg';


const WarningTextSpan = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #FFFFFF;
`

const AssetStolenButtonDiv = styled.div`
    height: 36px;
    left: 16px;
    top: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FF6060;
    border-radius: 12px;
    width: 100%;
`

const BackToWalletButtonDiv = styled.div`
    height: 44px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

`

const ButtonTextSpan = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    letter-spacing: 0.1px;

    /* Light Button / Primary Foreground */

    color: #FFFFFF;

`
const ShowStealComponent = (props: any) => {
    return  (
        <div style={{
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'center',
            height:'100%',
            flexDirection:'column',
        }}>
          <img style={{marginLeft: 8}} src={error} alt='error icon' />
          <div style={{
              marginTop:65,
              marginBottom:130,
          }}>
            <p>
              <WarningTextSpan>
                For security reasons, We will not  provide you with seed phrase as
              </WarningTextSpan>
              <WarningTextSpan style={{color:'rgba(255, 96, 96, 1)'}}> your assets will be stolen!</WarningTextSpan>
            </p>

          </div>
          <AssetStolenButtonDiv>
            <img
                style={{marginRight: 8}} 
                src={asset_stolen_warning}
            />
            <ButtonTextSpan>
              YOUR ASSETS ARE AT RISK!
            </ButtonTextSpan>
          </AssetStolenButtonDiv>
          <BackToWalletButtonDiv
              onClick={() => {props.setOpen(false)}}
              style={{marginTop:28, marginBottom:16}}>
            <ButtonTextSpan>
              Back to wallet
            </ButtonTextSpan>
          </BackToWalletButtonDiv>
          
        </div>);
}

export default ShowStealComponent;
